import { OptionGroup } from 'element-ui'

const YOptionGroup = OptionGroup
YOptionGroup.$depends = [OptionGroup]
YOptionGroup.$name = 'y-OptionGroup'
YOptionGroup._name = 'OptionGroup 选择器选项组'

export default YOptionGroup
